import React from 'react';
import { Flex, Typography } from 'antd';

const { Text } = Typography;

const TotalRow = ({ label, value, bold, size, color }) => (
  <Flex
    justify="space-between"
    align="center"
    style={{
      padding: '6px 0',
      borderBottom: bold ? '1px solid var(--varexe-border-color)' : undefined,
    }}
  >
    <Text style={{ color: 'var(--varexe-gray-600)', fontSize: size || 13 }}>{label}</Text>
    <Text strong={bold} style={{ fontSize: size || 13, color: color || undefined }}>{value}</Text>
  </Flex>
);

export default TotalRow;
